import {
    CREATE_FABRIC_INWARD_FAILURE,
    CREATE_FABRIC_INWARD_REQUEST,
    CREATE_FABRIC_INWARD_SUCCESS,
    CREATE_USER_FORM_FABRIC_INWARD,
    FETCH_SINGLE_FABRIC_INWARD_FAILURE,
    FETCH_SINGLE_FABRIC_INWARD_REQUEST,
    FETCH_SINGLE_FABRIC_INWARD_SUCCESS,
    FETCH_FABRIC_INWARD_FAILURE,
    FETCH_FABRIC_INWARD_REQUEST,
    FETCH_FABRIC_INWARD_SUCCESS,
    NAVIGATE_FABRIC_INWARD_DETAILS,
    NAVIGATE_FABRIC_INWARD,
    FABRIC_INWARD_USERFORM_RESET,
    UPDATE_FABRIC_INWARD_FAILURE,
    UPDATE_FABRIC_INWARD_REQUEST,
    UPDATE_FABRIC_INWARD_SUCCESS,
    DELETE_FABRIC_INWARD_REQUEST,
    DELETE_FABRIC_INWARD_SUCCESS,
    DELETE_FABRIC_INWARD_FAILURE,
    FETCH_PENDING_FABRIC_PO_IN_INWARD_SUCCESS,
    FETCH_PENDING_FABRIC_PO_IN_INWARD_REQUEST,
    FETCH_PENDING_FABRIC_PO_IN_INWARD_FAILURE,
    SET_ACTIVE_KEY_FABRIC_INWARD,
    RESET_FORM_DATA_WITHOUT_FABRIC_INWARD_ID,
    SET_PENDING_GRID_NAME_FABRIC_INWARD,
    SET_UNIT_NAME_FABRIC_INWARD,
    SET_START_DATE_FABRIC_INWARD,
    SET_END_DATE_FABRIC_INWARD
} from './fabricInward.actionsType';

export const FABRIC_INWARD = 'fabricInward';

let initialState = {
    loading: false,
    fabricInward: [],
    pendingFabricPO: [],
    activeKey: 1,
    fabricInwardId: '',
    fabricInwardForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null
    },
    selectedTeam: {},
    isFabricInward: false,
    fabricInwardSelectedValue: null,
    errorMessage: '',
    renderGridBtn: 'pendingGrid',
    unitId: '',
    startDate: new Date().setDate(new Date().getDate() - 15),
    endDate: new Date(),
    iperrorMessage: ''
};

export let fabricInwardReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_FABRIC_INWARD_REQUEST:
        case FETCH_PENDING_FABRIC_PO_IN_INWARD_REQUEST:
        case CREATE_FABRIC_INWARD_REQUEST:
        case FETCH_SINGLE_FABRIC_INWARD_REQUEST:
        case UPDATE_FABRIC_INWARD_REQUEST:
        case DELETE_FABRIC_INWARD_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_FABRIC_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricInward: updatePayload
            };
        case FETCH_PENDING_FABRIC_PO_IN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingFabricPO: updatePayload
            };
        case CREATE_FABRIC_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null
                },
                fabricInwardId: updatePayload,
                activeKey: updatePayload[0]?.fldID && payload == true ? 2 : 1
            };
        case FETCH_SINGLE_FABRIC_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeam: updatePayload,
                fabricInwardForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case UPDATE_FABRIC_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeam: {},
                fabricInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null
                }
            };
        case DELETE_FABRIC_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null
                }
            };
        case FETCH_FABRIC_INWARD_FAILURE:
        case FETCH_PENDING_FABRIC_PO_IN_INWARD_FAILURE:
        case FETCH_SINGLE_FABRIC_INWARD_FAILURE:
        case CREATE_FABRIC_INWARD_FAILURE:
        case UPDATE_FABRIC_INWARD_FAILURE:
        case DELETE_FABRIC_INWARD_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_FABRIC_INWARD:
            return {
                ...state,
                loading: false,
                fabricInwardForm: {
                    ...state.fabricInwardForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_FABRIC_INWARD:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case SET_PENDING_GRID_NAME_FABRIC_INWARD:
            return {
                ...state,
                renderGridBtn: payload
            };
        case SET_UNIT_NAME_FABRIC_INWARD:
            return {
                ...state,
                unitId: payload
            };
            case SET_START_DATE_FABRIC_INWARD:
            return {
                ...state,
                startDate: payload
            };
            case SET_END_DATE_FABRIC_INWARD:
            return {
                ...state,
                endDate: payload
            };
        case FABRIC_INWARD_USERFORM_RESET:
            return {
                ...state,
                fabricInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null
                },
                selectedTeam: {},
                fabricInwardId: '',
                activeKey: 1
            };
        case RESET_FORM_DATA_WITHOUT_FABRIC_INWARD_ID:
            return {
                ...state,
                fabricInwardForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null
                },
                selectedTeam: {}
            };
        case NAVIGATE_FABRIC_INWARD_DETAILS:
            return {
                ...state,
                isFabricInward: true,
                fabricInwardSelectedValue: updatePayload.fabricInwardSelectedValue
            };
        case NAVIGATE_FABRIC_INWARD:
            return {
                ...state,
                isFabricInward: false
            };
        default:
            return state;
    }
};
